// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__147W8","amount":"Amount_amount__27wuM","tip":"Amount_tip__WJ6UQ","tipHeader":"Amount_tipHeader__3ehD2","tipsWrap":"Amount_tipsWrap__3NtTM"};